import { z } from 'zod';

export const MailTemplateSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: 'form.validation.mailNameRequired' }),
    subject: z.string().min(1, { message: 'form.validation.mailSubjectRequired' }),
    code: z.string().min(1, { message: 'form.validation.mailDescriptionRequired' }),
    body: z.string().min(1, { message: 'form.validation.mailContentRequired' }),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateMailTemplateSchema = MailTemplateSchema.omit({ id: true });
export const UpdateMailTemplateSchema = MailTemplateSchema;
export const MailTemplateFormSchema = MailTemplateSchema;